
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from 'react-toastify';
import {telegramSendMessage} from "./telegram-message-send.service";



const Contacts = () => {
  const { t } = useTranslation();
  let [name, setName] = useState<string>();
  let [email, setEmail] = useState<string>();
  let [subject, setSubject] = useState<string>();
  let [message, setMessage] = useState<string>();
  const botKey: string = process.env.REACT_APP_BOT_KEY || '';
  const chatId: string = process.env.REACT_APP_CHAT_ID || '';
  const displaySuccessMsg = () => {
      toast.success(t('contacts.success'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
      })
  }

    const displayErrorMsg = () => {
        toast.error(t('contacts.error'), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        })
    }

  const getClientData = () => {
    return `Новое сообщение от сайта
      Имя клиента - ${name},
      Почта - ${email},
      Тема - ${subject || 'Не указал'},
      Сообщение - ${message || 'Не указал'}`;
  }

  const clearForm = () => {
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
  }

  const handleSubmit = (e: any) => {
      e.preventDefault();
      const clientData = getClientData();
      const messageStatus = telegramSendMessage(botKey, chatId, clientData);
      messageStatus.then((success) => {
          success ? displaySuccessMsg() : displayErrorMsg();
          clearForm();
      })
  }

    return (
      <div className="portfolio-area ptb--120 bg_color--1" id="contact">
          <div className="contact-form--1">
              <div className="container">
                  <div className="row row--35 align-items-start">
                      <div className="col-lg-6 order-2 order-lg-1">
                          <div className="section-title text-left mb--50">
                              <h2 className="title">{t("contacts.title")}</h2>
                              <p className="description">{t("contacts.description")}</p>
                          </div>
                          <div className="form-wrapper">

                              <form onSubmit={e => {handleSubmit(e)}}>
                                  <label htmlFor="item01">
                                      <input
                                          type="text"
                                          name="name"
                                          id="item01"
                                          value={name}
                                          required
                                          onChange={e => setName(e.target.value)}
                                          placeholder={t('contacts.name') as string}
                                      />
                                  </label>

                                  <label htmlFor="item02">
                                      <input
                                          type="email"
                                          name="email"
                                          required
                                          id="item02"
                                          value={email}
                                          onChange={e => setEmail(e.target.value)}
                                          placeholder={t('contacts.email') as string}
                                      />
                                  </label>

                                  <label htmlFor="item03">
                                      <input
                                          type="text"
                                          name="subject"
                                          id="item03"
                                          value={subject}
                                          onChange={e => setSubject(e.target.value)}
                                          placeholder={t('contacts.subject') as string}
                                      />
                                  </label>
                                  <label htmlFor="item04">
                                        <textarea
                                            id="item04"
                                            name="message"
                                            value={message}
                                            onChange={e => setMessage(e.target.value)}
                                            placeholder={t('contacts.message') as string}
                                        />
                                  </label>
                                  <button className="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">{t('contacts.submit')}</button>
                              </form>
                          </div>
                      </div>
                      <div className="col-lg-6 order-1 order-lg-2">
                          <div className="thumbnail mb_md--30 mb_sm--30">
                              <img src="/assets/images/about/about-5.jpg" alt="Kensei contact us"/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Contacts;
